<template>
  <footer>
    <div class="container">
      <div class="footer-div">
        <img v-if="siteData.second_banner_url" class="img-fluid footer-bg-img" :src="siteData.second_banner_url"
          alt="footer bg">

        <!-- links & subscription form -->
        <div class="row mt-8">
          <!-- links -->
          <div class="col-12 col-lg-6">
            <div class="row footer-links-div">
              <div class="col-6 col-sm-4">
                <h6>{{ $t('main') }}</h6>
                <ul class="footer-links">
                  <li>
                    <router-link :to="/pages/ + fixedPages[0]?.display_url_slug">{{ fixedPages[0]?.title
                    }}</router-link>
                  </li>
                  <li>
                    <router-link to="/explanations">{{ $t("explanations") }}</router-link>
                  </li>
                </ul>
              </div>
              <div class="col-6 col-sm-4">
                <h6>{{ $t('society') }}</h6>
                <ul class="footer-links">
                  <li>
                    <router-link to="/contact-us">{{ $t("footer.contact") }}</router-link>
                  </li>
                  <li>
                    <router-link to="/faqs"> {{ $t("footer.faq") }}</router-link>
                  </li>
                </ul>
              </div>
              <div class="col-12 col-sm-4">
                <h6>{{ $t('support') }}</h6>
                <ul class="footer-links">
                  <li v-for="fixedPage in fixedPages.slice(1)" :key="fixedPage.id">
                    <router-link :to="/pages/ + fixedPage?.display_url_slug">{{ fixedPage?.title }}</router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- subscription form -->
          <div class="col-12 col-lg-6">
            <h1 class="subscription-form-title">{{ $t('subscribe-for-updates') }}</h1>
            <form dir="rtl" class="email-form" action="#" method="post">
              <div class="input-wrap">
                <input id="email" name="email" type="email" inputmode="email" :placeholder="$t('enter-your-email')"
                  required>
                <button type="submit" class="send-btn">
                  <svg v-if="lang === 'en'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#fff">
                    <title>
                      arrow-right</title>
                    <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                  </svg>
                  <span>{{ $t('send') }}</span>
                  <svg v-if="lang === 'ar'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#fff">
                    <title>
                      arrow-left</title>
                    <path d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z" />
                  </svg>
                </button>
              </div>
            </form>
          </div>
        </div>


        <!-- social icons - payment ways -->
        <div class="row align-items-center mt-8 pb-8">
          <v-col cols="12" md="6">
            <div class="row justify-content-center justify-content-lg-start align-items-center">
              <div class="col-auto" v-if="getSocial.facebook">
                <a :href="getSocial.facebook" target="_blank">
                  <div class="social-btn">
                    {{ $t('facebook') }}
                    <img src="/img/newMainPage/arrow-up-right.svg" alt="facebook icon">
                  </div>
                </a>
              </div>
              <div class="col-auto" v-if="getSocial.instagram">
                <a :href="getSocial.instagram" target="_blank">
                  <div class="social-btn">
                    {{ $t('instagram') }}
                    <img src="/img/newMainPage/arrow-up-right.svg" alt="instagram icon">
                  </div>
                </a>
              </div>
              <div class="col-auto" v-if="getSocial.telegram">
                <a :href="getSocial.telegram" target="_blank">
                  <div class="social-btn">
                    {{ $t('telegram') }}
                    <img src="/img/newMainPage/arrow-up-right.svg" alt="telegram icon">
                  </div>
                </a>
              </div>
              <div class="col-auto" v-if="getSocial.youtube">
                <a :href="getSocial.youtube" target="_blank">
                  <div class="social-btn">
                    {{ $t('youtube') }}
                    <img src="/img/newMainPage/arrow-up-right.svg" alt="youtube icon">
                  </div>
                </a>
              </div>
              <div class="col-auto" v-if="getSocial.snapchat">
                <a :href="getSocial.snapchat" target="_blank">
                  <div class="social-btn">
                    {{ $t('snapchat') }}
                    <img src="/img/newMainPage/arrow-up-right.svg" alt="snapchat icon">
                  </div>
                </a>
              </div>
              <div class="col-auto" v-if="getSocial.twitter">
                <a :href="getSocial.twitter" target="_blank">
                  <div class="social-btn">
                    {{ $t('twitter') }}
                    <img src="/img/newMainPage/arrow-up-right.svg" alt="twitter icon">
                  </div>
                </a>
              </div>
              <div class="col-auto" v-if="getSocial.whatsapp">
                <a :href="'https://wa.me/' + getSocial.whatsapp" target="_blank">
                  <div class="social-btn">
                    {{ $t('whatsapp') }}
                    <img src="/img/newMainPage/arrow-up-right.svg" alt="whatsapp icon">
                  </div>
                </a>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div
              class="payment__images d-flex justify-content-center justify-content-lg-end align-items-center flex-row flex-wrap gap-3">
              <div v-for="item in payment" :key="item.id">
                <img class="img-fluid" :src="item.image_url" :alt="item.name" />
              </div>
            </div>
          </v-col>
        </div>

        <!-- copyrights -->
        <div
          class="row justify-content-center justify-content-lg-between align-items-center text-center text-lg-start border-top pt-3">
          <div class="col-12 col-lg-auto">
            <p class="copyrights-p mb-0">{{ $t('copyrights-2025') }}</p>
          </div>
          <div class="col-12 col-lg-auto">
            <section class="copyrights">
              <span class="badge">{{ $t("designed-developed-by") }}</span>
              <a class="business-copyright-content" href="https://businessbuilding.sa/" target="_blank"
                rel="noopener noreferrer">
                <img class="icon__" src="/img/newMainPage/bb.svg" alt="Business Building" />
              </a>
            </section>
            <!-- <div class="d-inline-flex align-items-center gap-2">
              <p class="copyrights-p mb-0">{{ $t("designed-developed-by") }}</p>
              <img class="img-fluid" src="/img/newMainPage/bb4it.svg" width="35" alt="bb4it logo">
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  data() {
    return {
      active: false,
      whatsappSettingsTimeNow: '00:00',
      login_url: (process.env.NODE_ENV === 'development') ? 'https://spaces-backend.test/provider/login' : (['musawirspaces.com', 'www.musawirspaces.com'].includes(window.location.hostname)) ? 'https://dashboard.musawirspaces.com/provider/login' : 'https://dashboardtest.musawirspaces.com/provider/login',
      lang: localStorage.getItem("lang") || "ar",
    }
  },
  computed: {
    ...mapGetters([
      "GetUserData",
    ]),
    ...mapGetters("home", [
      "getSections",
      "getServices",
      "getSiteData",
      "getSocial",
      "getPayment",
      "getWhatsappSettings",
      "getFixedPages",
    ]),
    sections() {
      return this.getSections;
    },
    services() {
      return this.getServices;
    },
    siteData() {
      return this.getSiteData;
    },
    social() {
      return this.getSocial;
    },
    payment() {
      return this.getPayment;
    },
    whatsappSettings() {
      return this.getWhatsappSettings;
    },
    fixedPages() {
      return this.getFixedPages;
    },
  },
  mounted() {
    this.$store.dispatch("home/fetchSiteData");
  },
  methods: {
    slideToggle() {
      this.active = !this.active;
      let today = new Date();
      this.whatsappSettingsTimeNow = today.getHours() + ":" + today.getMinutes();
    },
    handleDashboardRedirect() {
      return axios.post("redirect-to-dashboard").then(res => {
        window.location.href = this.login_url + '?auth_token=' + res.data.data;
      }).catch(() => {
        window.location.href = this.login_url;
      })
    },
  }
};
</script>
<style scoped lang="scss">
.custom_links {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 0;
  flex-wrap: wrap;
}

.payment__images,
.footer_links {
  @media (max-width: 767px) {
    justify-content: flex-start !important;
    align-items: flex-start;
    margin-bottom: 20px;
    gap: 0;

    li {
      width: 50%;
      margin-bottom: 25px;
    }
  }
}

.social_links,
.payment__images {
  @media (max-width: 767px) {
    justify-content: center !important;
    align-items: center !important;
  }
}
</style>
<style scoped>
.v-application ol,
.v-application ul {
  padding: 0;
}

footer {
  background-color: #000;
  padding: 30px 20px;
}

footer .footer-div {
  border-radius: 24px;
  background-color: #FFF;
  padding: 45px 60px;
  color: #000;
  font-size: 16px;
  font-weight: normal;
  text-align: start;
}

footer .footer-div .footer-bg-img {
  width: 100%;
  height: 250px;
  object-fit: cover;
  border-radius: 16px;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.60) 0%, rgba(0, 0, 0, 0.60) 100%);
}

footer .footer-div .footer-links-div h6 {
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 26px;
}

footer .footer-div .footer-links-div .footer-links {
  list-style: none;
}

footer .footer-div .footer-links-div .footer-links li {
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  margin-bottom: 8px;
}

footer .footer-div .footer-links-div .footer-links li a {
  color: #5B5B5B;
  transition: 300ms ease-in-out;
}

footer .footer-div .footer-links-div .footer-links li a:hover {
  color: #333;
}

footer .footer-div .subscription-form-title {
  color: #232323;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px;
  width: 75%;
}

footer .footer-div .social-btn {
  border-radius: 8px;
  background: #F4F4F4;
  padding: 8px 16px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

footer .footer-div .social-btn:hover {
  background: #ccc;
  transition: 300ms ease-in-out;
}

@media (max-width: 768px) {
  footer {
    padding: 0;
  }

  footer .footer-div {
    border-radius: 24px;
    padding: 16px;
    font-size: 14px;
  }

  footer .footer-div .footer-bg-img {
    height: 185px;
  }

  footer .footer-div .footer-links-div h6 {
    font-size: 18px;
    line-height: 26px;
  }

  footer .footer-div .footer-links-div .footer-links li {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 8px;
  }

  footer .footer-div .subscription-form-title {
    font-size: 16px;
    line-height: 24px;
    width: 100%;
  }

  footer .copyrights-p {
    color: #1E1E1E;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
}
</style>

<!-- subscription form -->
<style scoped>
/* ===== Shell ===== */
.input-wrap {
  position: relative;
  background: #fafafa;
  border: 1px solid #e6e6e6;
  border-radius: 14px;
  padding: 10px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, .9),
    0 2px 8px rgba(0, 0, 0, .06);
}

/* ===== Input ===== */
.input-wrap input {
  width: 100%;
  height: 46px;
  border: 0;
  background: transparent;
  color: #0f0f0f;
  font-size: 16px;
  padding-inline: 16px;
  /* room for the left button */
  padding-left: 140px;
  padding-right: 8px;
  text-align: right;
  /* placeholder on the right like the mock */
  outline: none;
}

[lang='en'] .input-wrap input {
  padding-left: 8px;
  padding-right: 125px;
  text-align: left;
}

.input-wrap input::placeholder {
  color: #a7a7a7;
}

.input-wrap:focus-within {
  border-color: #d7d7d7;
  box-shadow: 0 0 0 3px rgba(0, 0, 0, .03),
    0 2px 10px rgba(0, 0, 0, .08),
    inset 0 1px 0 rgba(255, 255, 255, .9);
}

/* ===== Button ===== */
.send-btn {
  position: absolute;
  left: 8px;
  /* button sits inside the left edge */
  top: 50%;
  transform: translateY(-50%);
  height: 44px;
  padding: 0 16px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  /* keeps arrow to the left of the text in RTL */
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, .85);
  color: #fff;
  font-weight: 600;
  font-style: normal;
  cursor: pointer;
  background: linear-gradient(180deg, #2a2a2a 0%, #0b0b0b 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, .12),
    0 1px 2px rgba(0, 0, 0, .35);
}

[lang='en'] .send-btn {
  left: unset;
  right: 8px;
}

.send-btn:hover {
  background: linear-gradient(180deg, #333 0%, #0a0a0a 100%);
}

.send-btn:active {
  transform: translateY(-50%) scale(.98);
}

.send-btn svg {
  width: 18px;
  height: 18px;
  display: block;
}

/* Optional: shrink padding on small screens */
@media (max-width: 768px) {
  .input-wrap input {
    font-size: 14px;
    padding-left: 100px;
  }

  .send-btn {
    height: 48px;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
  }

  .send-btn svg {
    width: 24px;
    height: 24px;
  }
}

.business-copyright-content span {
  color: #B1B1B1;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 14.256px;
  /* 89.102% */
  letter-spacing: -0.132px;
}

.business-copyright-content .icon__ {
  width: 35px;
}

.copyright-content-wrapper {
  padding: 2.8rem 0;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

a {
  text-decoration: none !important;
}

section.copyrights {
  position: relative;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-self: end;
  gap: 8px;
  /* padding-top: 12px; */
}

@media (max-width: 993px) {
  section.copyrights {
    justify-self: center;
  }
}

.badge {
  position: absolute;
  top: -35px;
  /* space above logo */
  left: 50%;
  transform: translateX(-50%);
  background: #000000;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 10px;
  border-radius: 4px;
  line-height: 1;
  white-space: nowrap;
  z-index: 2;

  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease;
  pointer-events: none;
}

section.copyrights:hover .badge {
  opacity: 1;
  visibility: visible;

}

/* triangle */
section.copyrights:hover .badge::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;

  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #000000;
}
</style>